import gql from 'graphql-tag'

export default gql`
    query checkVZF($vzf: String!) {
        checkVZF(vzf: $vzf) {
            isValid
            vzf {
                selectedProductCategories
                multipleSelectOptionList {
                    key
                    value
                }
                startOfDelivery
                startOfMarketing
                zipcode
                city
                street
                houseNumber
                additionalInfo
                email
                customizeType
                vouchers {
                    code
                    id
                    type
                    name
                    value {
                        currency
                        isOnce
                        month
                        value
                    }
                    infoText
                    articleNumber
                    products {
                        articleId
                        name
                        price
                        type
                    }
                    actions {
                        name
                        price
                        type
                    }
                }
            }
            vzfID
        }
    }
`
